'use strict';

//Включает логирование всех событий. Используется для отладки.
//window.ENABLE_EVENTS_LOGGING = true;
//window.ENABLE_EVENTS_LOGGING_JQUERY = true;

(function (global) {

  // Список уровней логирования и соответствующих ему типов логируемых сообщений.
  const includedLevels = Object.freeze({
    D: [ 'E', 'W', 'I', 'D' ],
    E: [ 'E' ],
    I: [ 'E', 'W', 'I' ],
    W: [ 'E', 'W' ],
  });

  // Ассоциативный массив соответствия строковых значений уровней ошибок их значениям в перечислении.
  const logLevels = Object.freeze({
    debug: LOG_LEVEL.DEBUG,
    error: LOG_LEVEL.ERROR,
    info: LOG_LEVEL.INFO,
    warn: LOG_LEVEL.WARN,
    warning: LOG_LEVEL.WARN,
  });

  /**
   * Предоставляет инструменты для логирования.
   * В режиме отладки веб-доступ записывает все действия в лог-файлы.
   * Данные файлов впоследствии можно использовать для отладки веб-модулей.
   *
   * @namespace WebAccess.utils.log
   * @since 5.1.0.1523
   *
   * @example
   * WA.utils.log.info('Загружен новый веб-модуль «Модуль 1.0»');
   * // Либо использовать второй вариант записи.
   * log.info('Загружен новый веб-модуль «Модуль 1.0»');
   */
  class Log extends BaseObject {

    constructor() {
      super();

      // Инициализация
      this.className = 'Log';
      this._disabled = true;
      this.saveImmediate = false;
      this.maxStackSize = 50;
      if (!this.isDisabled()) {
        this._disabled = false;
      }
    }

    /**
     * Привести строковое значение уровня ошибки к значению перечисления.
     *
     * @method _strToLevel
     * @param {string} level Уровнеь ошибки.
     * @private
     * @return {LOG_LEVEL} Значение уровня ошибки из перечисления.
     */
    strToLevel(level) {
      return logLevels[level] || null;
    }

    /**
     * Получить уровень логирования.
     *
     * @method getLevel
     * @return {string} Строка с уровнем логирования.
     */
    getLevel() {
      return WA.cache.getItem('log.level') || this.strToLevel(Core.logLevel) || LOG_LEVEL.ERROR;
    }

    /**
     * Установить уровень логирования.
     *
     * @method setLevel
     * @param {string} level Уровень логирования.
     * @return {WebAccess.utils.Log} Текущий объет логера.
     */
    setLevel(level) {
      WA.cache.setItem('log.level', level);
      return this;
    }

    /**
     * Проверить, отключено ли логирование.
     * Значение по умолчанию True.
     *
     * @method WebAccess.utils.log.isDisabled
     * @return {Boolean} True – логирование отключено, иначе False.
     */
    isDisabled() {
      return (!window.isDebug && WA.cache.getItem('log.isEnabled') !== 'true');
    }

    /**
     * Включить логирование.
     * По умолчанию логирование отключено.
     *
     * @method WebAccess.utils.log.enable
     * @return {WebAccess.utils.log} Объект типа log.
     */
    enable() {
      WA.cache.setItem('log.isEnabled', 'true');
      this._disabled = false;
      return this;
    }

    /**
     * Отправить логи на клиентские логи на сервер.
     *
     * @method _write
     * @param {object} params Параметры обращения к методу веб-сервиса.
     * @return {WebAccess.utils.Log} Текущий объект логера.
     * @private
     */
    _write(params) {
      if (!Core.isLogsEnabled || this._disabled || WA.getLocation() === 'login' || !params) {
        return this;
      }
      if (this.saveImmediate) {
        WA.SRV.request('/ClientLogs.asmx/Write', params);
      } else {
        const queue = WA.cache.getObject('logs') || [];
        queue.push(params);
        WA.cache.setObject('logs', queue);
        if (queue.length > this.maxStackSize) {
          this._writeQueue();
        }
      }
      return this;
    }

    /**
     * Выгрузить текущий пакет лога на веб-сервер.
     * @method WebAccess.current.statistics._writeQueue
     * @private
     */
    _writeQueue() {
      if (this._disabled) {
        return this;
      }
      let queue = WA.cache.getObject('logs');
      const partToSend = queue.splice(0, this.maxStackSize);
      WA.cache.setObject('logs', queue);

      WA.SRV.request('/ClientLogs.asmx/writeQueue', {
        Queue: partToSend,
      }).done((success) => {
        if (!success) {
          queue = [
            ...partToSend,
            ...WA.cache.getObject('logs'),
          ];
          WA.cache.setObject('logs', queue);
        }
      });
      return this;
    }

    /**
     * Отключить логирование.
     * По умолчанию логирование отключено.
     *
     * @method WebAccess.utils.log.enable
     * @return {WebAccess.utils.log} Объект типа log.
     */
    disable() {
      WA.cache.setItem('log.isEnabled', 'false');
      this._disabled = true;
      return this;
    }

    /**
     * Записать предупреждение в лог.
     * По умолчанию логирование отключено.
     *
     * @method WebAccess.utils.log.warn
     * @param {string} tag Тэг
     * @param {string} message Сообщение
     * @return {WebAccess.utils.log} Объект типа log.
     */
    warn(tag, message) {
      return this._log(LOG_LEVEL.WARN, tag, message);
    }

    /**
     * Записать предупреждение в лог.
     * По умолчанию логирование отключено.
     *
     * @method WebAccess.utils.log.warning
     * @param {string} tag Тэг
     * @param {string} message Сообщение
     * @alias WebAccess.utils.log.warn
     * @return {WebAccess.utils.log} Объект типа log.
     */
    warning(tag, message) {
      return this.warn(tag, message);
    }

    /**
     * Записать в лог информационное сообщение.
     *
     * @method WebAccess.utils.log.info
     * @param {string} tag Тэг
     * @param {string} message Сообщение
     * @return {WebAccess.utils.log} Объект типа log.
     * @since 5.1.0.1523
     *
     * @example
     * // Для вывода информационного сообщения INFO Веб-модуль успешно загружен
     * WA.utils.log.info('INFO', 'Веб-модуль успешно загружен.');
     *
     * // Для вывода информационного сообщения DEFAULT Веб-модуль успешно загружен
     * WA.utils.log.info('Веб-модуль успешно загружен.');
     */
    info(tag, message) {
      return this._log(LOG_LEVEL.INFO, tag, message);
    }

    /**
     * Записать в лог сообщение об ошибке.
     *
     * @method WebAccess.utils.log.error
     * @param {string} tag Тэг
     * @param {string} message Сообщение
     * @return {WebAccess.utils.log} Объект типа log.
     * @since 5.1.0.1523
     */
    error(tag, message) {
      return this._log(LOG_LEVEL.ERROR, tag, message);
    }

    /**
     * Отобразить в консоли последние сообщения, ожидающие отправки на веб-сервер.
     *
     * @method WebAccess.utils.log.showLastMessages
     * @return {WebAccess.utils.log} Объект типа log.
     */
    showLastMessages() {
      const queue = WA.cache.getObject('logs') || [];
      for (const line of queue) {
        const dt = new Date(line.Time);
        const fd = formatDateTime(dt).split(' ')[ 1 ] + ':' + dt.getSeconds() + '.' + dt.getMilliseconds();
        console.log(fd + ' ' + line.Level + ' ' + line.Tag + ' ' + line.Message);
      }
      return this;
    }

    /**
     * Отобразить последнее сообщение.
     *
     * @method last
     */
    last() {
      this.showLastMessages();
    }

    /**
     * Сохранить лог в файл на веб-сервере.
     *
     * @method WebAccess.utils.log.save
     * @return {WebAccess.utils.log} Объект типа log.
     */
    save() {
      this._writeQueue();
      return this;
    }

    /**
     * Записать в лог сообщение об отладке
     * @method WebAccess.utils.log.debug
     * @return {WebAccess.utils.log} Объект типа log.
     * @since 5.1.0.1523
     */
    debug(tag, message) {
      return this._log(LOG_LEVEL.DEBUG, tag, message);
    }

    /**
     * Непосредственная обрабтка вызовов записи в журнал
     * @method WebAccess.utils.log._log
     * @return {WebAccess.utils.log}
     * @private
     * @since 5.1.0.1523
     */
    _log(level, tag, message) {
      if (this._disabled) {
        return;
      }

      let messages;
      if (message) {
        messages = [ message ];
        tag = tag.toUpperCase();
      } else {
        messages = [ tag ];
        tag = 'DEFAULT';
      }

      if (includedLevels[ this.getLevel() ].indexOf(level) === -1) return this;

      const dt = new Date();
      const t = formatDateTime(dt).split(' ')[ 1 ] + ':' + dt.getSeconds() + '.' + dt.getMilliseconds();
      this.fire('onMessage', level, t, tag, messages);

      const params = { 'Time': new Date(), 'Tag': tag, 'Level': level, 'Message': messages.join(' ') };
      const logParams = [ t, tag ].concat(messages).join(' ');

      if (WA.ENV.browser.name !== 'IE') {
        switch (level) {
          case LOG_LEVEL.ERROR:
            console.error(logParams);
            break;
          case LOG_LEVEL.INFO:
            console.info(logParams);
            break;
          case LOG_LEVEL.WARN:
            console.warn(logParams);
            break;
          case LOG_LEVEL.DEBUG:
          default:
            console.log(logParams);
        }
      } else {
        console.log(logParams);
      }

      this._write(params);
      return this;
    }
  }

  global.log = new Log();
  window.onerror = (errorMsg, url, lineNumber) => {
    if (!WA.ENV.isTouch()) {
      log.error('DEFAULT', format('{0} {1}:{2}', errorMsg, url, lineNumber));
    } else {
      logDebug('ERROR: ' + format('{0} {1}:{2}', errorMsg, url, lineNumber));
    }
    return false;
  }

})(window.WebAccess.utils);


//Шамов А.: Для отладки событий.
if (window.ENABLE_EVENTS_LOGGING && window.ENABLE_EVENTS_LOGGING_JQUERY) {
  var prevOn = jQuery.fn.on;
  jQuery.fn.on = function () {
    console.log('jQuery.on', arguments);
    return prevOn.apply(this, arguments);
  };

  var prevOff = jQuery.fn.off;
  jQuery.fn.off = function () {
    console.log('jQuery.off', arguments);
    return prevOff.apply(this, arguments);
  };

  var prevTrigger = jQuery.fn.trigger;
  jQuery.fn.trigger = function () {
    if (!WA.ENV.isTouch()) {
      console.log('jQuery.trigger', arguments);
    } else {
      logDebug('jQuery.trigger ' + arguments[ 0 ]);
    }
    return prevTrigger.apply(this, arguments);
  };

  var prevTriggerHandler = jQuery.fn.triggerHandler;
  jQuery.fn.triggerHandler = function () {
    if (!WA.ENV.isTouch()) {
      console.log('jQuery.triggerHandler', arguments);
    } else {
      logDebug('jQuery.triggerHandler ' + arguments[ 0 ]);
    }
    return prevTriggerHandler.apply(this, arguments);
  };
}